import React, { Fragment } from "react"
import StatsPieChart from "../../components/Stat/StatsPieChart"
import StatsColumnChart from "../../components/Stat/StatsColumnChart"
import { Card, Col, Row } from "reactstrap"
import StatsPolarChart from "../../components/Stat/StatsPolarChart"
import StatsRadialChart from "../../components/Stat/StatsRadialChart"
import StatsGradeEnseignant from "../../components/Stat/StatsGradeEnseignant"

const Stats = () => {
  return (
    <Fragment>
      <Row>
        <Col md={6} lg={6} xl={6}>
          <Card>
            <div style={{ padding: "20px" }}>
              <StatsPieChart />
            </div>
          </Card>
        </Col>

        <Col md={6} lg={6} xl={6}>
          <Card>
            <div style={{ padding: "20px" }}>
              <StatsPolarChart />
            </div>
          </Card>
        </Col>
        <Col md={6} lg={6} xl={6}>
          <Card>
            <div style={{ padding: "20px" }}>
              <StatsRadialChart />
            </div>
          </Card>
        </Col>
        <Col md={6} lg={6} xl={6}>
          <Card>
            <div style={{ padding: "20px" }}>
              <StatsGradeEnseignant />
            </div>
          </Card>
        </Col>
        <Col md={12} lg={12} xl={12}>
          <Card>
            <div style={{ padding: "30px" }}>
              <StatsColumnChart />
            </div>
          </Card>
        </Col>
        {/*<Col md={12} lg={12} xl={12}>*/}
        {/*  <Card>*/}
        {/*    <div style={{ padding: "30px" }}>*/}
        {/*      /!*<StatsCalendar />*!/*/}
        {/*    </div>*/}
        {/*  </Card>*/}
        {/*</Col>*/}
      </Row>

    </Fragment>
  )
}
export default Stats
